import { giftcardToken, isTokenValid } from "@/utils";
import { encrypt } from "@/utils/encodingdecoding";
import { baseURL } from "@/utils/url";

export const customerView = async (token, data) => {
    try {
        const fetchResponse = await fetch(baseURL + `CustomerProfileData?customerCode=${data}`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            // body: JSON.stringify(data),
            id: data,
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};

export const createreceipt = async (token, body) => {
    try {
        const fetchResponse = await fetch(`${baseURL}customerReceiptData`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse;
    } catch (error) {
        return error;
    }
};

export const verifyUPIID = async (token, body) => {
    try {
        const fetchResponse = await fetch(`${baseURL}verifyBank`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};

export const verifyUPI = async (token, body) => {
    try {
        const fetchResponse = await fetch(`${baseURL}verifyUpi`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};


export const updateStatus = async (token, id, status) => {
    try {
        const fetchResponse = await fetch(`${baseURL}updateQRStatus?id=${id}&status=${status}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse;
    } catch (error) {
        return error;
    }
};


export const getData = async (token, code) => {
    try {
        const fetchResponse = await fetch(baseURL + `getQrData?code=${code}`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            // body: JSON.stringify(data),
            id: code,
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};

export const getProduct = async (token, merchantCode) => {
    try {
        const fetchResponse = await fetch(baseURL + `getProductManagemt?merchantCode=${merchantCode}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            // body: JSON.stringify(data),
            // id: code,
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};


export const getCustomerReceipt = async (token, customercode) => {
    try {
        const fetchResponse = await fetch(baseURL + `getCustomerReceiptData?customercode=${customercode}`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};


export const getVoucherByCode = async (token, voucherCode) => {
    try {
        const fetchResponse = await fetch(baseURL + `getVoucherByCode?voucherCode=${voucherCode}`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        const response = await fetchResponse.json();

        return response;
    } catch (error) {
        return error;
    }
};

export const transactions = async (token, data) => {

    try {
        const fetchResponse = await fetch(baseURL + "transactionregistration", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const response = await fetchResponse.json();
        return response;
    } catch (error) {
        return error;
    }
};
export const RedeemVoucher = async (token, body) => {
    try {

        const fetchResponse = await fetch(baseURL + "redeemvoucher", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const transferBalance = async (token, body) => {
    try {
        const encryptedData = encrypt(body);
        const fetchResponse = await fetch(baseURL + "initiateAmount", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: encryptedData,
            }),
        });

        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const assignVoucherdata = async (token, data) => {

    try {
        const fetchResponse = await fetch(baseURL + "assignVoucher", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const response = await fetchResponse.json();
        return response;
    } catch (error) {
        return error;
    }
};

export const fulfilmentToken = async (body) => {
    try {
        const fetchResponse = await fetch(`https://apicustomerportalsaas.cladev.com/web/api/fulfilmentToken`, {
            method: "POST",
            headers: {
                Authorization: "Bearer ",
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};


export const getCustomerGiftcard = async (token, merchant_code, country) => {
    token = await giftcardToken();
    if (!token || !isTokenValid(token)) {
        return { error: "Token is expired and could not be refreshed." };
    }

    try {
        const fetchResponse = await fetch(`https://apicustomerportalsaas.cladev.com/web/api/getCustomerGiftcard`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const dynamicAPI = async (token, body) => {
    try {
        const fetchResponse = await fetch(baseURL + "dynamicAPI", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });

        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const transactionredeem = async (token, body) => {
    try {
        const fetchResponse = await fetch(baseURL + "transactionredeem", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });

        return await fetchResponse.json()
    } catch (error) {
        return error;
    }
};

export const sendSms = async (token, body) => {
    try {
        const fetchResponse = await fetch("https://apicustomerportalsaas.cladev.com/web/api/sendverify", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });

        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

